'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useCartReturnUrl } from '@/app/(order)/cart/_utils/use-cart-return-url';
import { MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT } from '@/app/(pdp)/constants';
import { useNavigateLogin } from '@/app/_utils/session/use-navigate-login';
import useGetCartCount from '@/app/_utils/use-cart-count';
import { cn } from '@/utils/cn';
import useUser from '@/utils/use-user';
import { NAVIGATION_ITEMS, exceptedUrls } from './constants';
import { NavigatoinBarItem } from './types';
import { useChatbotOpen } from '../chatbot/use-chatbot-open';
import { useCategoryModal } from '../header/category-modal/context/category-modal-context';
function NavigationBar() {
  const pathname = usePathname();
  const {
    user
  } = useUser();
  const router = useRouter();
  const navigateLogin = useNavigateLogin();
  const {
    cartCount
  } = useGetCartCount();
  const {
    open: openCategoryModal,
    isOpen: isCategoryModalOpen,
    close: closeCategoryModal
  } = useCategoryModal();
  const {
    isChatOpen
  } = useChatbotOpen();
  const {
    setCartBackReturnUrl
  } = useCartReturnUrl();
  const hideNavigation = exceptedUrls.some(url => pathname.includes(url));
  if (hideNavigation) return;
  const navigationClickHandler = (id: NavigatoinBarItem, url: string) => {
    if (id === NavigatoinBarItem.Profile && !user) {
      navigateLogin();
      return;
    }
    if (id === NavigatoinBarItem.Cart) setCartBackReturnUrl();
    if (id === NavigatoinBarItem.Categories) {
      isCategoryModalOpen ? closeCategoryModal() : openCategoryModal();
      return;
    }
    if (isCategoryModalOpen) closeCategoryModal();
    router.push(url);
  };
  return <div id='navigation-bar' className={cn('border-mediumGray fixed -bottom-0.5 left-0 right-0 z-navigation-bar flex h-14 items-center rounded-t-lg border border-b-transparent bg-white pb-1 lg:hidden', {
    hidden: isChatOpen
  })} style={{
    viewTransitionName: 'app-navigator'
  }} data-sentry-component="NavigationBar" data-sentry-source-file="index.tsx">
            {NAVIGATION_ITEMS.map(({
      href,
      id,
      title,
      default_icon: DefaultIcon,
      active_icon: ActiveIcon
    }) => {
      const isActive = pathname === href && !isCategoryModalOpen || isCategoryModalOpen && id === 'categories';
      return <div key={id} onClick={() => navigationClickHandler(id, href)} className='relative flex-1 select-none text-text-darkGray'>
                        <div className='flex flex-col items-center justify-center gap-0.5'>
                            <div className='relative flex justify-center'>
                                {isActive ? <ActiveIcon className='h-6 w-6 shrink-0 text-black' /> : <DefaultIcon className='h-6 w-6 shrink-0' />}
                                {!!cartCount && id === 'cart' && <span className='absolute -right-1.5 top-2 flex h-4 w-4 items-center justify-center rounded-full bg-primary-main p-0.5 text-center text-caption-10 font-medium text-white'>
                                        {cartCount > MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT ? `${MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT}+` : cartCount}
                                    </span>}
                            </div>
                            <span className='block text-caption-10 font-medium'>{title}</span>
                        </div>
                    </div>;
    })}
        </div>;
}
export default NavigationBar;